import React from "react";
import { css } from "emotion";
import Input from "../../../../../../offers/shared/AtomicInput";

import {
	pageFidelityPrograms,
	loadingStyle,
	pageFidelityProgramsFlex,
	pageFidelityProgramsSearch,
	pageFidelityProgramsSearchInput
} from "./style";
import BoxCompanies from "../../../../../shared/create-offer/BoxCompanies/BoxCompanies";
import Loading from "../../../../../shared/create-offer/Loading/Loading";

const StepFidelityProgram = props => {
	return props.loading ? (
		<div
			className={css`
				${loadingStyle};
			`}
		>
			<Loading />
		</div>
	) : (
		<div
			className={css`
				${pageFidelityProgramsFlex};
			`}
		>
			<div
				className={css`
					${pageFidelityProgramsSearch};
				`}
			>
				<p>Selecione abaixo o programa onde estão suas milhas:</p>
				<div
					className={css`
						${pageFidelityProgramsSearchInput};
					`}
				>
					<Input
						name="search"
						id="search"
						type="text"
						placeholder="Pesquisar programa"
						onChange={ev => props.filterCompanies(ev.target.value)}
						icon="icon-search"
						data-action="fidelity-programs-search"
					/>
				</div>
			</div>
			<div
				className={css`
					${pageFidelityPrograms};
				`}
			>
				<BoxCompanies companies={props.companies} onClick={obj => props.onChange(obj)} />
			</div>
		</div>
	);
};

export default StepFidelityProgram;
